export enum SidenavSide {
    LEFT,
    RIGHT
}

export enum SidenavAction {
    OPEN,
    CLOSE,
    TOGGLE
}

export enum SidenavTemplate {
    GENERIC_ASIDE,
    MENU,
    OFFER_PROPERTY_CONFIG,
    OFFER_MOTOR_CONFIG,
    PARTY_EDITOR,
    CESSION_EDITOR,
    OFFER_PROPERTY_READONLY,
    OFFER_MOTOR_READONLY,
    OFFER_FRONTIER_READONLY,
}

export namespace AsideAction {
    export class Generic {
        static readonly type = 'AsideAction.Generic';

        constructor(public side: SidenavSide, public type: SidenavAction, public template: SidenavTemplate = null) {
        }
    }

    export class CloseAll {
        static readonly type = 'AsideAction.CloseAll';
    }

    export function CloseRight() {
        return new Generic(SidenavSide.RIGHT, SidenavAction.CLOSE);
    }
}
